import { LoginEmailForm } from "../../organisms/form/LoginEmailForm";
import { CardTemplate } from "../../templates/CardTemplate";
import { useLogin } from "./hook";

export const LoginPage: React.FC = () => {
  const { handleLogin } = useLogin();

  return (
    <CardTemplate title="ログイン">
      <LoginEmailForm handleSubmit={handleLogin} />
    </CardTemplate>
  );
};
